import { createErrorReportingAsyncThunk } from "../../helpers";
import axios from "../../../axios";

const prefix = "data/heartbeat";

// Background call, so a failure is reported but never toasts the user.
export const sendHeartbeat = createErrorReportingAsyncThunk(
  `${prefix}/sendHeartbeat`,
  async () => {
    // Only touches last_active_at, so sending it twice is harmless.
    await axios.post(`/api/heartbeat`, undefined, {
      retryWhileDatabaseUnavailable: true,
    });
  },
  { skipNotification: true }
);
